/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-11-10 10:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import Classnames from 'classnames';
import { Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getTemplateImage, MAPPING_THEME_NAME } from 'src/constants/theme-settings';

type Props = {
  activeMenuItem: string,
  formValues: any,
  themeLibTemplate: string,
  boostThemeLib: string
};

type ComposedProps = Props & WithI18nProps;

class TemplateItem extends Component<ComposedProps> {
  handleSelectTheme = () => {
    const { onSelect, theme } = this.props;
    onSelect(theme);
  };

  handleViewDemo = () => {
    const { onViewDemo, theme } = this.props;
    onViewDemo(theme);
  };

  render() {
    const { i18n, theme, themeLibTemplate, boostThemeLib } = this.props;
    const templateImage = getTemplateImage(theme?.themeName);
    const isSelected = themeLibTemplate
      ? theme?.themeName === themeLibTemplate
      : theme?.themeName === boostThemeLib;
    const templateItemClass = Classnames('BC-template-item', {
      active: isSelected
    });

    return (
      <div className={templateItemClass} id={`template-item-${MAPPING_THEME_NAME[theme?.themeName]}`}>
        <div className="BC-template-item__thumbnail">
          <img src={templateImage.thumbnail} alt="thumbnail" />
          {isSelected && (
            <div className="BC-template-item__selected-tag">
              <span>{i18n.translate('AdminHTML.ThemeSetting.LayoutModal.currentTemplate')}</span>
            </div>
          )}
          <div className="overlay">
            <Button primary onClick={this.handleSelectTheme}>
              {i18n.translate('AdminHTML.ThemeSetting.Common.select')}
            </Button>
            <Button onClick={this.handleViewDemo}>
              {i18n.translate('AdminHTML.ThemeSetting.Common.viewDemo')}
            </Button>
          </div>
        </div>
        <p className="BC-template-item__name">{MAPPING_THEME_NAME[theme?.themeName]}</p>
      </div>
    );
  }
}

export default withI18n()(TemplateItem);
